import React, { useState, useEffect, useRef } from 'react';
import { firebase } from "../firebase"
import {addDoc, collection} from "@firebase/firestore"
import Hero from "./components/Hero.jsx"
import Services from './components/Services.jsx';
import About from "./components/About.jsx";
import Contact  from './components/Contact.jsx';        
import Footer from './components/Footer.jsx';
import Reviews from './components/Reviews.jsx';
export default function Home() {
  const [selectedService, setSelectedService] = useState(null);

    const ref = collection(firebase,"messages");

  const messageRef = useRef();

  const handleContactClick = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };


  const handleServiceClick = (serviceId) => {
    setSelectedService(serviceId);
    setTimeout(() => {
      document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };
  const handleSave = async(e)=>{
    e.preventDefault();
    console.log(messageRef.current.value);
    let data = {
        message: messageRef.current.value
    }
    try{
        addDoc(ref, data);
    }catch(e){

        console.log(e);

    }


  }

  return (
      

      
      <div className="min-h-screen ">
        <Hero onContactClick={handleContactClick} />
        <Services onServiceClick={handleServiceClick} />
        <About />
        <Reviews />
        <Contact />
        <Footer />
       

        
    </div>
  );
}